import './ReportPageHeader.scss';

import { Paper, Typography } from '@trackman/web-shared-components';
import {
  PitchType,
  PitchTypeGroup,
  PlayerHandedness,
  StrikeZoneDisplay,
  UmpireCall,
  UmpireCallCorrectness,
} from 'types/CodegenReportTypes';

import { useTranslation } from 'react-i18next';
import { umpireCallCorrectnessOptions } from 'utilities/constants';

type Props = {
  pitchTypes?: PitchType[];
  pitchTypeGroups?: PitchTypeGroup[];
  pitcherHandedness: PlayerHandedness;
  batterHandedness: PlayerHandedness;
  zoneViewMode: StrikeZoneDisplay;
  callCorrectness?: UmpireCallCorrectness[];
  umpireCall?: UmpireCall;
};

const UmpireConditions = ({
  pitchTypes,
  pitchTypeGroups,
  pitcherHandedness,
  batterHandedness,
  zoneViewMode,
  callCorrectness,
  umpireCall,
}: Props) => {
  const { t } = useTranslation();

  return (
    <div className='UmpireConditions-container'>
      <Paper className='UmpireConditions-paper'>
        <Typography variant='h2' component='div'>
          {t('ReportConditions')}
        </Typography>
        <div className='UmpireConditions-config-container'>
          <div>
            <Typography variant='label' color='#A0A0A0'>
              {t('batterHandedness')}
            </Typography>
            <Typography>{t(batterHandedness)}</Typography>
          </div>
          <div>
            <Typography variant='label' color='#A0A0A0'>
              {t('pitcherHandedness')}
            </Typography>
            <Typography>{t(pitcherHandedness)}</Typography>
          </div>
          <div>
            <Typography variant='label' color='#A0A0A0'>
              {t('Buffers')}
            </Typography>
            <Typography>{t('short.' + zoneViewMode)}</Typography>
          </div>
          {callCorrectness != null && (
            <div>
              <Typography variant='label' color='#A0A0A0'>
                {t('CallCorrectness')}
              </Typography>
              <Typography>
                {callCorrectness.length === umpireCallCorrectnessOptions.length ||
                (zoneViewMode === 'WithoutBuffers' && callCorrectness.length === umpireCallCorrectnessOptions.length - 1)
                  ? t('All')
                  : callCorrectness.map((callCorrectness) => t(callCorrectness)).join(', ')}
              </Typography>
            </div>
          )}
          {umpireCall != null && (
            <div>
              <Typography variant='label' color='#A0A0A0'>
                {t('UmpireCall')}
              </Typography>
              <Typography>{t(umpireCall)}</Typography>
            </div>
          )}
          {pitchTypes != null && (
            <div>
              <Typography variant='label' color='#A0A0A0'>
                {t('pitchType')}
              </Typography>
              <div className='subcontainer'>
                {pitchTypes.length === 0 ? (
                  <Typography>-</Typography>
                ) : (
                  pitchTypes.map((pitchType) => <Typography key={pitchType}>{t('short.' + pitchType)}</Typography>)
                )}
              </div>
            </div>
          )}
          {pitchTypeGroups != null && (
            <div>
              <Typography variant='label' color='#A0A0A0'>
                {t('parentPitchType')}
              </Typography>
              <div className='subcontainer'>
                {pitchTypeGroups.length === 0 ? (
                  <Typography>-</Typography>
                ) : (
                  pitchTypeGroups.map((group) => <Typography key={group}>{t(group)}</Typography>)
                )}
              </div>
            </div>
          )}
        </div>
      </Paper>
    </div>
  );
};

export default UmpireConditions;
